// extracted by mini-css-extract-plugin
var _1 = "HomeAbout__container--TWBLa";
var _2 = "HomeAbout__content--Oczj3";
var _3 = "HomeAbout__link--yB6Jn";
var _4 = "HomeAbout__logo--xqNT1";
var _5 = "HomeAbout__redBottom--qXVR8";
var _6 = "HomeAbout__sectionCloser--Gk7JJ";
var _7 = "HomeAbout__textBlue--FRJqX";
export { _1 as "container", _2 as "content", _3 as "link", _4 as "logo", _5 as "redBottom", _6 as "sectionCloser", _7 as "textBlue" }
